import { makeStyles } from 'tss-react/mui';
import { colors, hideScrollbars, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        display: 'flex',
        padding: theme.isFlyingFlowers ? '11px 8px 9px 9px' : 'unset',
        marginRight: spacing.large,
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            padding: theme.isFlyingFlowers ? `14px 8px 14px 9px` : 'unset',
            marginRight: spacing.medium,
        },
        [theme.breakpoints.down('xl')]: Object.assign({ overflowX: 'auto', whiteSpace: 'nowrap', maxWidth: '340px', marginRight: 0 }, hideScrollbars),
    },
    trustpilotContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: `${spacing.xs} 0`,
        alignItems: 'center',
        height: '60px',
    },
    ukCarouselBreakPoints: {
        width: '100vw',
        '& .react-multi-carousel-track': {
            height: '60px',
        },
        '& .react-multi-carousel-dot button': {
            width: '12px',
            height: '12px',
            marginRight: '12px',
            borderWidth: '1px',
            backgroundColor: colors.grey.grey3,
        },
        '& .react-multi-carousel-list': {
            height: '60px',
        },
        '& .react-multi-carousel-dot--active button': {
            backgroundColor: colors.grey.grey6,
        },
        padding: `0  ${spacing.xs} 0 ${spacing.xs}`,
        [theme.breakpoints.up('md')]: {
            padding: `0  124px`,
        },
        [theme.breakpoints.up('lg')]: {
            padding: `0 252px`,
        },
    },
    carouselItem: {
        margin: 0,
        '& > div': {
            display: 'flex',
            justifyContent: 'center',
        },
    },
    carouselContainer: {
        width: '100%',
    },
    leftButton: {
        left: 0,
        paddingRight: spacing.xs,
        background: 'inherit',
    },
    rightButton: {
        right: 0,
        paddingLeft: spacing.xs,
        background: 'inherit',
    },
    customButtonGroup: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        position: 'absolute',
        top: '50%',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
        [`& .${classes.leftButton}, & .${classes.rightButton}`]: {
            position: 'absolute',
            '& button': {
                width: '24px',
                height: '24px',
                minHeight: '24px',
                backgroundColor: 'inherit',
                transition: 'unset',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
                '&:focus': {
                    outline: 'none',
                    boxShadow: 'none',
                    backgroundColor: 'unset',
                },
                '&.MuiFab-root': {
                    width: '24px',
                    height: '40px',
                    border: 0,
                },
                '& .MuiIcon-root': {
                    width: 'unset',
                    height: 'unset',
                    fontSize: '24px !important',
                },
            },
        },
    },
    slider: {},
}));
export default useStyles;
